// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2cpdj","modalFooterButton":"ModalNotes_modalFooterButton__10uH-"};